/**
 * DLP APi
 * DLP Services
 *
 * OpenAPI spec version: 1.0
 * Contact: check
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { AdminResponse } from '../model/adminResponse';
import { AdminSignupDto } from '../model/adminSignupDto';
import { UsrUser } from '../model/usrUser';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { baseUrl } from 'src/environments/environment';


@Injectable()
export class AdminSignUpControllerService {

    //protected basePath = "http://10.203.44.168:8080/nrfsi/nissan";
    protected basePath = baseUrl;
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * addAdmin
     * 
     * @param adminSignupDto adminSignupDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addAdminUsingPOST(adminSignupDto: AdminSignupDto, observe?: 'body', reportProgress?: boolean): Observable<UsrUser>;
    public addAdminUsingPOST(adminSignupDto: AdminSignupDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UsrUser>>;
    public addAdminUsingPOST(adminSignupDto: AdminSignupDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UsrUser>>;
    public addAdminUsingPOST(adminSignupDto: AdminSignupDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (adminSignupDto === null || adminSignupDto === undefined) {
            throw new Error('Required parameter adminSignupDto was null or undefined when calling addAdminUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        // if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
        //     headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        // }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<UsrUser>(`${this.basePath}admin/signup`,
            adminSignupDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * addImage
     * 
     * @param file file
     * @param id id
     * @param roles roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addImageUsingPOST(file: Blob, id: string, roles: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public addImageUsingPOST(file: Blob, id: string, roles: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public addImageUsingPOST(file: Blob, id: string, roles: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public addImageUsingPOST(file: Blob, id: string, roles: Array<string>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

       

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling addImageUsingPOST.');
        }

        if (roles === null || roles === undefined) {
            throw new Error('Required parameter roles was null or undefined when calling addImageUsingPOST.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }
        if (roles) {
            roles.forEach((element) => {
                queryParameters = queryParameters.append('roles', <any>element);
            })
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        // if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
        //     headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        // }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (file !== undefined) {
           formParams.append('file', <any>file);
        }

        return this.httpClient.post<boolean>(`${this.basePath}admin/image`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteAdmin
     * 
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteAdminUsingDELETE(id: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public deleteAdminUsingDELETE(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public deleteAdminUsingDELETE(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public deleteAdminUsingDELETE(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteAdminUsingDELETE.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        // if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
        //     headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        // }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<boolean>(`${this.basePath}admin/delete`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

   /**
     * editAdmin
     * 
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public editAdminUsingGET(id: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public editAdminUsingGET(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public editAdminUsingGET(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public editAdminUsingGET(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling editAdminUsingGET.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        // if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
        //     headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        // }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<boolean>(`${this.basePath}admin/edit`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }


    /**
     * fetchAdmin
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fetchAdminUsingGET(observe?: 'body', reportProgress?: boolean): Observable<Array<AdminResponse>>;
    public fetchAdminUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AdminResponse>>>;
    public fetchAdminUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AdminResponse>>>;
    public fetchAdminUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        // if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
        //     headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        // }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<AdminResponse>>(`${this.basePath}admin/admin`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
